import { AfterViewInit, Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { SocialSecurityService } from 'src/app/pages/privado/services/previdencia/social-security.service';
import { AnalisePagamentoPdfComponent } from '../../pdf/analise-pagamento-pdf/analise-pagamento-pdf.component';
@Component({
  selector: 'app-modal-analise-pagamento',
  templateUrl: './modal-analise-pagamento.component.html',
  styleUrls: ['./modal-analise-pagamento.component.css']
})
export class ModalAnalisePagamentoComponent implements AfterViewInit{

  showButton:boolean = false;

  @Input() paymentAnalyze: any;

  loading: boolean = false;

  constructor(public activeModal: NgbActiveModal, private socialSecurityService: SocialSecurityService,  private modalService: NgbModal) { }

  exportToPDF() {   
    this.loading = true;
    const modalRef = this.modalService.open(AnalisePagamentoPdfComponent, { windowClass: 'download-pdf', size:"lg", centered: true });
    modalRef.componentInstance.paymentAnalyze = this.paymentAnalyze;    
    modalRef.result.then(
      (res:any)=>{
        this.loading = false;
        this.activeModal.close();
      }
    );    

    // let reference = moment(this.paymentAnalyze.paymentDate).format('YYYY-MM-DD');
    // this.socialSecurityService.getPaymentAnalyzePdf({reference: reference, register: this.paymentAnalyze.register}).subscribe((pdf: any) => {
    //   const a = document.createElement('a');
    //   a.setAttribute('style', 'display:none;');
    //   document.body.appendChild(a);
    //   a.download = "Analise de pagamento - " + moment(this.paymentAnalyze.paymentDate).format('MM-YYYY') + " - " + this.paymentAnalyze.register;
    //   a.href = URL.createObjectURL(pdf.body);
    //   a.target = '_blank';
    //   a.click();
    //   document.body.removeChild(a);

    //   this.loading = false;
    // })



  }

  ngAfterViewInit(): void {
    setTimeout( ()=>{
      this.showButton = true;
    },500 );    
  }

}
